<template>
  <v-row class="mx-0 mt-2 mb-4">
    <v-col v-if="loaded">
      <v-row>
        <v-col class="pt-0">
          <v-layout align-center mb-5 class="successTitle">
            <div>
              <v-icon x-large color="success">{{ successIcon }}</v-icon>
            </div>
            <v-flex v-if="successTitleMsgText" mx-2 class="title" mt-1>
              <label v-html="successTitleMsgText"></label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              v-if="successBodyMsgText"
              class="caption successInnerTitle mb-3"
            >
              <div v-html="successBodyMsgText"></div>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-2">
          <v-btn
            elevation="0"
            block
            class="mainButton redirectionBtn"
            :class="startLoading"
            :loading="loading"
            :rounded="templateConfig.isButtonRounded"
            @click="redirectToMerchantPage()"
          >
            <span v-html="successBtnText" v-if="!loading"></span>
          </v-btn>
        </v-col>
      </v-row>
      <SecondaryDisclaimer v-if="successSecondaryDisclaimerText">
        <div v-html="successSecondaryDisclaimerText" class="secondryDisc"></div>
      </SecondaryDisclaimer>
    </v-col>
    <v-col v-else>
      <MainLoader />
    </v-col>
  </v-row>
</template>

<script>
import { mdiCheckCircleOutline } from '@mdi/js'; // named import for success icon.
import { mapState } from 'vuex';
import storedData from "constants/storedData";
import MainLoader from '../../Shared/components/MainLoader.vue';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';

export default {
  components: { MainLoader, SecondaryDisclaimer },
  computed: {
    ...mapState(['OTPDetails', 'merchantConfig', 'templateConfig']),
    successBtnText() {
      //Needs $replacePlaceholders plugin function for [productName] placeholder.
      return this.$replacePlaceholders(this.merchantConfig.texts.successBtn, {
        productName: this.successData.productName,
      });
    },
    successSecondaryDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.successSecondaryDisclaimer;
    },
    successTitleMsgText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.successTitleMsg;
    },
    successBodyMsgText() {
      //Needs $replacePlaceholders plugin function for [productName, price, currency, msisdn] placeholder.
      return this.$replacePlaceholders(
        this.merchantConfig.texts.successBodyMsg,
        {
          productName: this.successData.productName,
          price: this.successData.amountCharged,
          currency: this.successData.currency?.replaceAll('.', ' '),
          msisdn: this.successData.msisdn,
        }
      );
    },
  },
  data() {
    return {
      successData: {},
      loaded: false,
      startLoading: '',
      loading: false,
      successIcon: mdiCheckCircleOutline,
    };
  },
  methods: {
    redirectToMerchantPage() {
      this.loading = true;
      window.location.replace(this.successData.redirectUrl);
    },
  },
  async created() {
    let isHybridPaymentConfig = this.merchantConfig.configs.isHybridPayment;
    let response = await this.$http.get(
      `/Payment/GetPaymentConfirmationResponse/otp?OperationStatusCode=success&PreserveUser=${isHybridPaymentConfig}`
    );
    /*========= response object Template ========== */
    // let response = {
    //   data: {
    //     amountCharged: 7,
    //     currency: 'جنيه مصرى',
    //     msisdn: '201270240983',
    //     productCatalogName: 'HETest',
    //     productName: '100 Points',
    //     redirectUrl:
    //       'https://www.my-redirect.com?operationStatusCode=0&transactionId=34&amountCharged=7&operatorCode=60201&msisdn=201270240983&orderInfo=order123&productCatalogName=HETest&productId=100Points&language=2&errorMessage=&checkoutId=0HMDJV3957DHH:00000081&signature=0oa70WuefiddqLjqlTlp:d896b8608842b6cf469160c154bfd941a7bea3c6265e284ba03e070a2b2a5985',
    //     responseCode: 0,
    //     statusCode: 1,
    //   },
    // };
    /*============================================= */

    this.successData = response.data;
    this.loaded = true;
    // save MSISDN and Operator code on success.
    localStorage.setItem('msisdn', this.successData.msisdn);
    localStorage.setItem('operatorCode', this.successData.operatorCode);

    this.$gtag.event('Success', {
      event_category: 'OTP',
      event_label: this.successData.productName,
    });

    setTimeout(() => {
      this.startLoading = 'startLoading';
    }, 100);

    setTimeout(() => {
      this.redirectToMerchantPage();
    }, 6000);

    sessionStorage.removeItem(storedData.isHybridTrial);
    sessionStorage.removeItem(storedData.hybridPaymentType);
  },
};
</script>

<style>
.productNameLbl {
  direction: ltr;
  display: inline-flex;
}
</style>
